import {
  FC,
  HTMLAttributes,
  PropsWithChildren,
  ReactElement,
  ReactEventHandler,
  ReactNode,
} from 'react';
import { Typography } from '@mui/material';

import { Toggle } from '@/designSystem/Form/Toggle/Toggle';

import useStyles from './styles';

type Props = {
  label: ReactNode;
  name: string;
  body: ReactElement | string;
  hasValue: boolean;
  onChange: ReactEventHandler;
} & HTMLAttributes<HTMLDivElement>;

const SelectorCard: FC<PropsWithChildren<Props>> = ({
  label,
  body,
  hasValue: value,
  name,
  onChange,
  className,
  children,
  title,
  ...rest
}) => {
  const { classes } = useStyles();

  const changevalue = (event) => {
    if (!event.target.getAttribute('data-stop-propagation')) {
      // @ts-ignore
      onChange({ target: { checked: !value, name } });
    }
  };

  return (
    <>
      {/* Keyboard support via the "<switch>" below */}
      {/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
      <div
        className={`${classes.root} ${className}`}
        {...rest}
        onClick={changevalue}
      >
        {/* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
        <div className={classes.titleContainer}>
          <Typography
            variant="bodyLg"
            component="span"
            className={classes.title}
          >
            {label}
          </Typography>
          <Toggle
            isChecked={value}
            name={name}
            onChange={onChange}
            color="primary"
            inputProps={{ 'aria-label': title }}
          />
        </div>
        <Typography
          variant="bodyMd"
          component="div"
          color="textSecondary"
          className={classes.body}
        >
          {body}
        </Typography>
        {children}
      </div>
    </>
  );
};

export default SelectorCard;
